import React from 'react'

import IconSvgContainer, { Props as IconSvgContainerProps } from './IconSvgContainer'

export type Props = IconSvgContainerProps

const IconChevronDown = (props: Props): React.ReactElement => (
    <IconSvgContainer width="18" height="11" {...props}>
        <path d="M1.75958 0.243524L-3.93267e-07 2.00311L8.99689 11L18 2.00311L16.2404 0.243523L8.99689 7.48083L1.75958 0.243524Z" />
    </IconSvgContainer>
)

export default IconChevronDown
